export const camerasKeys = {
    streamSettings: () => ['cameras', 'streamSettings']
};
//# sourceMappingURL=cameras.keys.js.map